module.exports = __webpack_public_path__ + "img/bg-auth-overlay.025fcdc0.png";